export const STATE_LOGIN = 'LOGIN';
export const STATE_FORGOT = 'FORGOT';